import { useMemo } from "react";
import Marquee from "react-fast-marquee";

const ITEMS = [
  "Forensic and Trauma",
  "Mould Remediation",
  "Water Damage Restoration",
  "Biohazard Removal",
  "Property Makesafe",
  "Property Strip Out",
  "Qualified Local Trade Partners",
];

export default function Ticker() {
  const items = useMemo(() => {
    const a = [...ITEMS];
    for (let i = a.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
  }, []);

  return (
    <div
      data-testid="ticker"
      className="border-y border-[#2a2a2a] bg-[#050505] py-6"
    >
      <Marquee speed={40} gradient={false} autoFill>
        {items.map((item, i) => (
          <div key={i} className="flex items-center">
            <span className="px-8 font-display text-2xl uppercase tracking-tight text-[#f5f5f0] md:text-3xl">
              {item}
            </span>
            <span className="text-[#c4a962]">◆</span>
          </div>
        ))}
      </Marquee>
    </div>
  );
}
